/* @flow */
export const VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};
